export default "/images/activated.png?944e553fbad57fef34702f479514dd09";